/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import I18n from 'components/Translate/I18n';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import Alert from 'react-bootstrap-sweetalert';
import PropTypes from 'prop-types';

class SuccessInfo extends PureComponent {
    render() {
        const { onConfirm, confirmBtnText, content } = this.props;
        return (
            <Alert
                success
                title=""
                style={{ display: 'block' }}
                onConfirm={onConfirm}
                confirmBtnText={<I18n trans={confirmBtnText} />}
                confirmBtnCssClass={this.props.classes.button + ' ' + this.props.classes.success}
            >
                <Typography variant="subtitle2">
                    <I18n trans={content} />
                </Typography>
            </Alert>
        );
    }
}

SuccessInfo.propTypes = {
    classes: PropTypes.object.isRequired,
    onConfirm: PropTypes.func.isRequired,
    confirmBtnText: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
};

export default withStyles(adescomStyle)(SuccessInfo);
